export const USER_STATE_SET_SUCCESS = `USER_STATE_SET_SUCCESS`;
export const USER_STATE_SET_FAILED = `USER_STATE_SET_FAILED`;

export const setUserStateSuccess = payload => ({type: USER_STATE_SET_SUCCESS, payload});
export const setUserStateFailed = error => ({type: USER_STATE_SET_FAILED, error});
